import { useRef, useState } from "react";

import TamaraWidget from "./Tamara";
// import CalendarIcon from "@/components/icons/CalendarIcon";
// import ArrowIcon from "@/components/icons/ArrowIcon";
import useHandleOutside from "@/hooks/useHandleOutside";
import TabbyWidget from "@/product/installments/Tabby";
import BaseetaWidget from "@/product/installments/Baseeta";

const InstallmentWidgets = ({ amount, locale, fromPDP = false }) => {
  const availabeWidgets = {
    tamara: amount <= process.env.NEXT_PUBLIC_TAMARA_LIMIT_TO,
    mispay:
      amount >= process.env.NEXT_PUBLIC_MISPAY_LIMIT_FROM &&
      amount <= process.env.NEXT_PUBLIC_MISPAY_LIMIT_TO,
  };
  const [, setOpen] = useState(false);
  const [, setSelected] = useState("tamara");
  const ref = useRef();
  useHandleOutside(ref, () => setOpen(false));
  return !fromPDP ? (
    <>
      <TamaraWidget locale={locale} amount={amount} />
      <TabbyWidget price={amount} locale={locale} />
      <BaseetaWidget price={amount} locale={locale} />
    </>
  ) : (
    <div
    // className={`relative ${
    //   selected === "tamara" ? "z-[900]" : "z-[400]"
    // } space-y-4`}
    >
      {Object.values(availabeWidgets)?.some((item) => item) && (
        <>
          <TamaraWidget
            setSelected={setSelected}
            locale={locale}
            amount={amount}
            fromPDP
          />
          <TabbyWidget
            setSelected={setSelected}
            setOpen={setOpen}
            price={amount}
            locale={locale}
          />

          <BaseetaWidget price={amount} locale={locale} />
          {/* <div className="bg-[#F4F3F3]" ref={ref}>
            <div
              className={`flex items-center justify-between px-4 max-sm:px-3 ${
                !open
                  ? "rounded-md py-3 max-sm:py-2"
                  : "rounded-t-md pt-3 max-sm:pt-2"
              } cursor-pointer`}
              onClick={() => setOpen(!open)}
            >
              <div className="flex items-center gap-1">
                <CalendarIcon />
                <span className="font-bold max-sm:text-sm">
                  {selected === "tamara" ? (
                    <>
                      {(amount / 4)?.toFixed(2)}{" "}
                      {locale === "en"
                        ? "SR Per Month / 4 Months"
                        : "ر.س لكل شهر / 4 شهور"}{" "}
                    </>
                  ) : (
                    <>
                      {(amount / 3)?.toFixed(2)}{" "}
                      {locale === "en"
                        ? "SR Per Month / 3 Months"
                        : "ر.س لكل شهر / 3 شهور"}{" "}
                    </>
                  )}
                </span>
              </div>
              <ArrowIcon
                className={`${
                  !open
                    ? "rotate-90"
                    : locale === "en"
                    ? "rotate-0"
                    : "rotate-180"
                }`}
              />
            </div>
            {open ? (
              <div className="absolute max-sm:*:text-sm *:mb-2 pt-2 z-30 bg-[#F4F3F3] rounded-b-md *:w-[95%] *:mx-auto *:bg-white top-full start-0">
                <TamaraWidget
                  setSelected={setSelected}
                  locale={locale}
                  amount={amount}
                  fromPDP
                />
                <TabbyWidget
                  setSelected={setSelected}
                  setOpen={setOpen}
                  price={amount}
                  locale={locale}
                />
              </div>
            ) : null}
          </div> */}
        </>
      )}
    </div>
  );
};

export default InstallmentWidgets;
